import { useMemo } from "react";
import { FileSpreadsheet, CheckCircle } from "lucide-react";

import { formatDateTime } from "@/utils/dateFormatter";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";

const STATUS_MAP = {
	open: { label: "Abierta", variant: "warning" },
	closed: { label: "Cerrada", variant: "success" },
};

export function useInventoryTakingColumns(tableState, { onFinalize, onExport } = {}) {
	return useMemo(() => {
		return [
			{
				Header: "#",
				accessor: "",
				disableSortBy: true,
				width: "3%",
				Cell: ({ row }) => {
					return <span>{(tableState.page - 1) * tableState.per_page + row.index + 1}</span>;
				},
			},
			{
				Header: "Bodega",
				accessor: "estate_name",
				width: "14%",
				Cell: ({ value }) => <span>{value || "-"}</span>,
			},
			{
				Header: "Usuario",
				accessor: "user_name",
				width: "12%",
				Cell: ({ value }) => <span>{value || "-"}</span>,
			},
			{
				Header: "Estado",
				accessor: "status",
				width: "8%",
				meta: { cellClassName: "tdCenter" },
				Cell: ({ value }) => {
					const config = STATUS_MAP[value] || { label: value, variant: "neutral" };
					return (
						<CustomBadge variant={config.variant} size="sm">
							{config.label}
						</CustomBadge>
					);
				},
			},
			{
				Header: "Inicio",
				accessor: "started_at",
				width: "12%",
				Cell: ({ value }) => formatDateTime(value) || "-",
			},
			{
				Header: "Finalización",
				accessor: "finalized_at",
				width: "12%",
				Cell: ({ value }) => formatDateTime(value) || "-",
			},
			{
				Header: "Esperados",
				accessor: "total_expected",
				width: "8%",
				meta: { cellClassName: "tdRight" },
				Cell: ({ value }) => <span>{value ?? 0}</span>,
			},
			{
				Header: "Faltantes",
				accessor: "total_missing",
				width: "8%",
				meta: { cellClassName: "tdRight" },
				Cell: ({ value }) => (
					<span style={{ color: value > 0 ? "var(--color-danger)" : undefined, fontWeight: value > 0 ? 500 : undefined }}>{value ?? 0}</span>
				),
			},
			{
				id: "actions",
				Header: "",
				disableSortBy: true,
				width: "5%",
				Cell: ({ row }) => {
					const isOpen = row.original.status === "open";
					const isClosed = row.original.status === "closed";

					const items = [];

					if (isOpen && onFinalize) {
						items.push({
							label: "Finalizar toma",
							action: () => onFinalize(row.original),
							icon: CheckCircle,
						});
					}

					if (isClosed && onExport) {
						items.push({
							label: "Exportar a Excel",
							action: () => onExport(row.original, row.index),
							icon: FileSpreadsheet,
						});
					}

					if (items.length === 0) return null;

					return (
						<div style={{ textAlign: "center" }}>
							<CustomDropdown title="Acciones" items={items} align="right" />
						</div>
					);
				},
			},
			{
				Header: "",
				accessor: "_expand",
				disableSortBy: true,
				width: "3%",
				Cell: () => null,
			},
		];
	}, [tableState, onFinalize, onExport]);
}
